import { styled, Typography } from '@mui/material';

export const DisableDialogContentStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_3,
}));
